export const resetUserStatus = (reset) => {
  return {
    type: 'RESET_USER_STATUS',
    payload: reset,
  }
}

export const userError = (error) => {
  return {
    type: 'USER_ERROR',
    payload: error,
  }
}

export const setUser = (data) => {
  return {
    type: 'SET_USER',
    payload: data,
  }
}

export const getUserCsat = (data) => {
  return {
    type: 'GET_USER_CSAT',
    payload: data,
  }
}

export const setUserCsat = (data) => {
  return {
    type: 'SET_USER_CSAT',
    payload: data,
  }
}
